import { formFieldComponents } from '@/forms/components/FormListItemContainer';
import { formFieldErrors } from '@/forms/helper';
import TaskObjectsTable from './components/TaskObjectsTable';

export const validateRequestTaskSection = (form, { sections }, section) => (
  formFieldErrors(form, `task.invalid.section.${section}`, sections[section]?.fields || [], section)
);

export default {
  objects: { editor: TaskObjectsTable, component: TaskObjectsTable, hasLabel: true },
  ...formFieldComponents,
};
